<template>
  <v-app class="app">
    <header-component v-if="showGlobalHeader" />
    <v-main>
      <router-view />
    </v-main>
    <navegation-mobile />
    <footer-component />
  </v-app>
</template>

<script>
import FooterComponent from '@/components/FooterComponent.vue';
import HeaderComponent from '@/components/HeaderComponent'
import NavegationMobile from '@/components/components-mobile/NavegationMobile.vue'

export default {
  name: 'App',
  components: {
    HeaderComponent,
    NavegationMobile,
    FooterComponent
  },
  computed: {
    showGlobalHeader() {
      const isSocialRoute = this.$route.matched.some(record => record.meta.socialRoute);
      return !isSocialRoute || this.$vuetify.breakpoint.width > 650;
    }
  }
}
</script>

<style scoped>
.app {
  background-color: #000000 !important;
  width: 100% !important;
}

.v-main {
  background-color: #000000 !important;
}

p {
  color: #fff;
}
</style>
